import { Component, inject } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { ChangeDetectionStrategy } from '@angular/core';
import { MibButtonDirective, MibIconComponent, MibLogoMedinboxComponent } from '@medinbox/angular';

@Component({
  selector: 'mai-auth-error-page',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MibLogoMedinboxComponent, MibButtonDirective, MibIconComponent, RouterLink],
  templateUrl: `./auth-error-page.html`,
})
export class AuthErrorPage {
  private readonly route = inject(ActivatedRoute);

  error(): string {
    return this.route.snapshot.queryParamMap.get('error') ?? 'unknown_error';
  }

  description(): string {
    switch (this.route.snapshot.queryParamMap.get('error_description')?.toLowerCase()) {
      case 'email_not_verified':
        return 'Your email address has not been verified yet. Please confirm your email from the message we sent you, then try signing in again.';
      case 'access_denied':
        return 'Access was denied. Your account may not have permission to sign in. Please contact your administrator.';
      case 'unauthorized':
        return 'You are not authorized to sign in. Please contact your administrator.';
      case 'login_required':
        return 'Your session has expired. Please sign in again.';
      case 'invalid_request':
        return 'The sign-in request was invalid. Please try again or contact support.';
      default:
        return 'An unexpected error occurred during authentication. Please try again or contact support.';
    }
  }
}
